export default __webpack_public_path__ + "static/media/bike3.35a1e312.png";